import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_cashbook_recon_config_RowClass } from '../../dbschema/bl_fi_mst_cashbook_recon_config.model';

export class LinkConfigToCashbookContainerModel extends BaseContainerModel {
  bl_fi_mst_cashbook_recon_config: bl_fi_mst_cashbook_recon_config_RowClass = new bl_fi_mst_cashbook_recon_config_RowClass();
}
